'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  .commander-result {\n    padding: 5px;\n    display: flex;\n\n    &:first-child {\n      border-top: 1px solid #ccc;\n    }\n  }\n\n  .commander-result-item {\n    flex: auto;\n  }\n'], ['\n  .commander-result {\n    padding: 5px;\n    display: flex;\n\n    &:first-child {\n      border-top: 1px solid #ccc;\n    }\n  }\n\n  .commander-result-item {\n    flex: auto;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fuzzaldrinPlus = require('fuzzaldrin-plus');

var _fuzzaldrinPlus2 = _interopRequireDefault(_fuzzaldrinPlus);

var _downshift = require('downshift');

var _downshift2 = _interopRequireDefault(_downshift);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledResults = _styledComponents2.default.div(_templateObject);
var FuzzyAutocomplete = function FuzzyAutocomplete(_ref) {
  var _onChange = _ref.onChange,
      placeholder = _ref.placeholder,
      items = _ref.items,
      itemStringKey = _ref.itemStringKey,
      _ref$itemReturnKey = _ref.itemReturnKey,
      itemReturnKey = _ref$itemReturnKey === undefined ? null : _ref$itemReturnKey,
      onInputChange = _ref.onInputChange;

  return _react2.default.createElement(
    _downshift2.default
    // defaultIsOpen={true}
    ,
    { isOpen: true,
      onChange: function onChange(item) {
        _onChange(item);
      },
      defaultInputValue: '',
      selectedItem: '',
      defaultHighlightedIndex: 0,
      itemToString: function itemToString(i) {
        return i ? i[itemStringKey] : '';
      },
      breakingChanges: { resetInputOnSelection: true }
    },
    function (_ref2) {
      var getInputProps = _ref2.getInputProps,
          getItemProps = _ref2.getItemProps,
          getLabelProps = _ref2.getLabelProps,
          highlightedIndex = _ref2.highlightedIndex,
          inputValue = _ref2.inputValue,
          isOpen = _ref2.isOpen,
          selectedItem = _ref2.selectedItem;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('label', getLabelProps()),
        _react2.default.createElement('input', _extends({
          autoFocus: true
        }, getInputProps({
          placeholder: placeholder
        }))),
        _react2.default.createElement(
          StyledResults,
          null,
          (!inputValue || inputValue.length === 0 ? items : _fuzzaldrinPlus2.default.filter(items, inputValue, {
            key: itemStringKey
          })).map(function (item, index) {
            return _react2.default.createElement(
              'div',
              _extends({
                className: 'commander-result'
              }, getItemProps({
                key: itemStringKey ? item[itemStringKey] : item,
                index: index,
                item: item,
                style: {
                  backgroundColor: highlightedIndex === index ? '#f5f5f5' : 'white'
                }
              })),
              _react2.default.createElement(
                'div',
                { className: 'commander-result-item' },
                item.label && _react2.default.createElement(
                  'span',
                  {
                    className: 'item-label',
                    style: {
                      background: item.label.background,
                      color: 'white',
                      padding: '1px 3px',
                      borderRadius: '2px',
                      marginRight: '5px'
                    }
                  },
                  item.label.copy
                ),
                inputValue.length === 0 ? _react2.default.createElement(
                  'span',
                  null,
                  item[itemStringKey]
                ) : _react2.default.createElement('span', {
                  dangerouslySetInnerHTML: {
                    __html: _fuzzaldrinPlus2.default.wrap(item[itemStringKey], inputValue)
                  }
                })
              ),
              item.shortcut && _react2.default.createElement(
                'div',
                { className: 'item-shortcut' },
                _react2.default.createElement(
                  'span',
                  {
                    className: 'item-shortcut',
                    style: {
                      textAlign: 'right',
                      color: 'steelblue'
                    }
                  },
                  item.shortcut
                )
              )
            );
          })
        )
      );
    }
  );
};

exports.default = FuzzyAutocomplete;


//////////////////
// WEBPACK FOOTER
// ./~/react-commander/lib/components/FuzzyAutocomplete.js
// module id = 835
// module chunks = 107818501498521